/**
 * What is told to Sentry about a refused sign-in renewal: the app, what happened and the server's code,
 * and nothing else. The app sets the person's id and email on Sentry for its error reports, and any
 * event picks them up (Codex's review 079), so these events are cut down to a fixed list of fields at
 * the last moment before sending. At most one of each outcome per page load.
 */
export const DIAGNOSTIC = 'sign-in-renewal';

const KEPT_FIELDS = ['event_id', 'timestamp', 'level', 'platform', 'message', 'environment', 'release'];
const KEPT_TAGS = ['diagnostic', 'app', 'outcome', 'code'];

const pick = (from, keys) => Object.fromEntries(keys.filter((k) => from?.[k] !== undefined).map((k) => [k, from[k]]));

// For Sentry's beforeSend: other events pass untouched
export const stripDiagnostic = (event) =>
  event?.tags?.diagnostic === DIAGNOSTIC
    ? { ...pick(event, KEPT_FIELDS), tags: pick(event.tags, KEPT_TAGS) }
    : event;

export const noteOncePerOutcome = (capture, app) => {
  const seen = new Set();
  return (outcome, code) => {
    if (seen.has(outcome)) return;
    seen.add(outcome);
    capture(`Sign-in renewal refused: ${outcome}`, { level: 'warning', tags: { diagnostic: DIAGNOSTIC, app, outcome, code } });
  };
};
